import React, { useState } from 'react';

import type Trip from '@this/domain/trip/trip2';
import { styled } from '@this/src/components/constants/themes';
import { getSpacing } from '@this/src/components/shared/ui/theme';
import { Button } from '@this/components/shared/ui/inputs/button';
import { Box } from '@material-ui/core';
import OrganizationModal from './organization_modal';

interface Props {
  trip: Trip;
  planName: string;
}
export const PartnerDescription: React.FC<Props> = ({ trip, planName }) => {
  const [showOrganizationModal, setShowOrganizationModal] = useState(false);

  const organizationId = trip?.user?.organization?.id;

  return (
    <div>
      <Section>
        <Box display="flex" justifyContent="space-between">
          <div>
            <SectionTitle>料金プラン</SectionTitle>
            <p>{planName}</p>
          </div>
          {organizationId && (
            <Section>
              <Button onClick={() => setShowOrganizationModal(true)}>企業情報</Button>
              <OrganizationModal
                show={showOrganizationModal}
                organizationId={organizationId}
                onClose={() => setShowOrganizationModal(false)}
              />
            </Section>
          )}
        </Box>
      </Section>
    </div>
  );
};

const Section = styled.section`
  & + & {
    margin-top: ${getSpacing(4)}px;
  }
`;

const SectionTitle = styled.h3`
  margin-bottom: ${getSpacing(1)}px;
`;
